import {
  NavLink as RouterNavLink,
  NavLinkProps as RouterNavLinkProps,
} from 'react-router-dom';
import { type ButtonFeatureProps } from '@ifrc-go/ui';
import { useButtonFeatures } from '@ifrc-go/ui/hooks';
import {
  _cs,
  isDefined
} from '@togglecorp/fujs'

import styles from './styles.module.css';

interface Props extends Omit<RouterNavLinkProps, 'className'> {
  className?: string;
  actions?: React.ReactNode;
  actionsContainerClassName?: string;
  disabled?: boolean;
  icons?: React.ReactNode;
  iconsContainerClassName?: string;
  spacing?: ButtonFeatureProps['spacing'];
}

function NavLink(props: Props) {
  const {
    actions,
    actionsContainerClassName,
    children: childrenFromProps,
    className,
    disabled: disabledFromProps,
    icons,
    iconsContainerClassName,
    to,
    activeClassName,
    spacing = 'cozy',

    ...otherProps
  } = props;

  const {
    children: content,
    className: containerClassName,
  } = useButtonFeatures({
    className: styles.navLink,
    icons,
    children: childrenFromProps,
    disabled: disabledFromProps,
    variant: 'tertiary',
    actions: isDefined(actions) ? (
      // eslint-disable-next-line react/jsx-no-useless-fragment
      <>
        {actions}
      </>
    ) : null,
    iconsContainerClassName,
    actionsContainerClassName,
    spacing,
  });

  return (
    <RouterNavLink
      {...otherProps}
      activeClassName={_cs(styles.active, activeClassName)}
      className={_cs(
        containerClassName,
        className,
      )}
      to={to}
    >
      {content}
    </RouterNavLink>
  );
}

export default NavLink;
